import React from 'react';
import { AlgoliaProductHit } from '../../utils/types';
import { ProductCard } from '@jbhi-fi/components/src/ProductCard';
import { ProductCardProps } from '@jbhi-fi/components/src/ProductCard/types';
import { AlgoliaHitTransformer } from '@jbhi-fi/components/src/Algolia/transformers/AlgoliaHitTransformer';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { GIFTCARDSKU } from '../../utils/gift-card';

type SearchProductCardWrapperProps = Partial<ProductCardProps> & {
  hit: AlgoliaProductHit;
  type: 'results' | 'modal';
  position: number;
  extraTracking?: {
    searchTerm?: string;
    searchMethod?: string;
    resultsFilters?: {
      category?: string;
      price?: {
        min?: string;
        max?: string;
      };
    };
  };
};

const SearchProductCardWrapperInternal = ({
  onClick,
  onAddToCart,
  type,
  hit,
  position,
  extraTracking,
  ...rest
}: SearchProductCardWrapperProps) => {
  const giftCardQueryString = `?value=${hit.price}`;

  const trackingDescriptor = {
    ...extraTracking,
    page: type === 'modal' ? 'search' : 'searchResults',
    group: type === 'modal' ? 'searchResults' : 'searchResultsProducts',
    currency: getStoreCurrency(),
    ecommerceExtraProps: {
      list: 'searchResults',
      position,
    },
  };

  const handleAddToCart = onAddToCart
    ? (e: any, _sku: any, variantId: any, eventData: any) => {
        return onAddToCart(e, _sku, variantId, eventData);
      }
    : undefined;

  return (
    <ProductCard
      {...AlgoliaHitTransformer.toProductCardProps(hit, {
        trackingDescriptor,
      })}
      onClick={onClick}
      onAddToCart={handleAddToCart}
      queryString={hit.sku === GIFTCARDSKU ? giftCardQueryString : undefined}
      tooltipVariant="small"
      tooltipPosition="top-end"
      {...rest}
    />
  );
};

export const SearchProductCardWrapper: React.ComponentType<SearchProductCardWrapperProps> =
  SearchProductCardWrapperInternal;
